import Vue from 'vue'
import { getURLParameter } from '../utils/common'

export const CHANGE_HISTORY = function (state, val) {
  Vue.set(state, 'history', val)
  for (const i in val) {
    if (val[i].name === 'name' && val[i].isValid) localStorage.setItem('customerName', val[i].value)
  }
}

export const CHANGE_AUTH_HISTORY = function (state, val) {
  Vue.set(state, 'authHistory', val)
}

const filledFields = []
export const UPDATE_FIELD = function (state, data) {
  let step = Object.hasOwn(data, 'customStep') ? data.customStep : state.currentStep
  const withoutFilledEvent = !!data.withoutFilledEvent
  delete data.customStep
  delete data.withoutFilledEvent
  if (data.name) { // we want to update not current step field
    for (let i in state.history) {
      if (state.history[i].name === data.name) {
        step = +i
        break
      }
    }
  }
  if (state.history[step].field && !state.history[step].field['game-type']) {
    console.warn('CLICK BUTTON TOO FAST')
    return
  }
  let temp = state.history
  const field = temp[step]
  for (let key in data) field[key] = data[key]
  field.showError = data.showError // if not true - we get undefined and hide error
  if (field.showError) {
    this.dispatch('sendCrezuEvent', { id: 5, data: {
        sub4: 'fieldInvalid',
        sub5: field.name,
        sub6: field.value,
        sub7: 'front'
      }
    })
    filledFields.splice(filledFields.indexOf(field.name), 1)
  }
  if (field.showCheckboxError) {
    this.dispatch('sendCrezuEvent', { id: 5, data: {
        sub4: 'fieldInvalid',
        sub5: 'agreements',
        sub6: state.remoteAgreementsErrors.join(','),
        sub7: 'front'
      }
    })
  }
  if (field.isValid && !filledFields.includes(field.name) && !withoutFilledEvent) {
    this.dispatch('sendCrezuEvent', {
      id: 5, data: {
        sub4: 'fieldFilled',
        sub5: field.name,
      }
    })
    filledFields.push(field.name)
  }
  Vue.set(state, 'history', temp)
}

export const CHANGE_STEP = function (state, val) {
  state.currentStep = val
  window.currentStep = val
}

export const CHANGE_CONFIG = function (state, val) {
  Vue.set(state, 'config', val)
}

export const CHANGE_ADDITIONAL_PARAMS = function (state, val) {
  let temp = state.additionalParams
  for (let i in val) {
    if (val[i] !== null && val[i] !== undefined) Vue.set(temp, i, val[i])
    if (i === 'lead_id') {
      localStorage.setItem('leadId', val[i])
      localStorage.setItem('lead_id', val[i])
    }
  }
  Vue.set(state, 'additionalParams', temp)
}

export const CHANGE_PRELOADER = function (state, val) {
  if (val) {
    state.preloader = {step: state.currentStep, type: state.history[state.currentStep].field['game-type']}
    let temp = JSON.parse(JSON.stringify(state.history))
    temp[state.currentStep].field['game-type'] = 'preloader'
    state.history = temp
  } else if (!val && state.preloader.type) {
    let temp = JSON.parse(JSON.stringify(state.history))
    temp[state.currentStep].field['game-type'] = state.preloader.type
    state.history = temp
  } else {
    // its only for first call
    console.warn('preloader already hidden')
  }
}

export const CHANGE_METHOD = function (state, val) {
  state.method = val
}

export const SHOW_INPUT_CHANGE_STATE = function (state, val) {
  state.showInput = val
}

export const SHOW_IFRAME = function (state, val) {
  state.iFrame = true
  state.iFrameLink = val
}

export const UPDATE_AUTOCOMPLETE = function (state, val) {
  state.JWTAutocomplete = val
}

export const UPDATE_ENV = function (state, { isDev, customBackendUrl }) {
  if (!isDev) {
    state.isDev = false
    state.backendUrl = 'https://leadgen.crezu.net'
    state.CDNUrl = 'https://cdn.crezu.net'
  } else {
    state.isDev = true
    state.backendUrl = 'https://staging.leadgen.crezu.net'
    state.CDNUrl = 'https://cdn.staging.crezu.net'
  }
  if (customBackendUrl) state.backendUrl = customBackendUrl
}

export const ADD_OFFERS = function (state, val) {
  state.offers = val
}

export const CHANGE_SELECTED_OFFERS = function (state, val) {
  state.selectedOffers = val
}

export const PUSH_FIELD_TO_DATALAYER = function (state, val) {
  state.historyToDataLayer.push([val, '-'])
}

export const UPDATE_FIELD_TIMING = function (state) {
  const currentTime = new Date().getTime()
  if (state.historyToDataLayer.length) {
    state.historyToDataLayer[state.historyToDataLayer.length - 1][1] = (currentTime - state.previousTime) / 1000
    state.previousTime = currentTime
  }
}

export const UPDATE_PERCENTS = function (state, val) {
  state.progressPercents += val
  if (state.progressPercents > 100) state.progressPercents = 100
}

export const CHANGE_FLOW = function (state, val) {
  state.flow = val
}

export const CHANGE_MANUAL_PROCESS_OFFERS = function (state, val) {
  state.manualProcessLenders = val
}

export const SHOW_TRANSIT_PAGE = function (state, val) {
  state.showTransitPage = val
}

export const SHOW_REDIRECT_POPUP = function (state, val) {
  if (val) {
    state.redirectPopupData = val
    state.showRedirectPopup = true
  } else {
    state.showRedirectPopup = false
  }
}

export const EXCLUDE_LENDER = function (state, val) {
  state.excludedLenders.push(val)
}

export const UPDATE_AVAILABLE_API_LENDERS = function (state, val) {
  state.availableAPILenders = val
}

export const ADD_RESUELVE_FIELDS = function (state) {
  const fields = ['zip', 'colony', 'city', 'municipality', 'state', 'has_other_loans', 'other_loans_amount', 'other_loans_company']
  const history = state.history
  for (const i in fields) {
    history[state.currentStep + 1 + +i] = { name: fields[i] }
  }
  state.history = history
}

export const CHANGE_PREDICTED_EMAIL_DOMAIN = function (state, val) {
  state.predictedEmailDomain = val
}

export const CHANGE_STEP_LABEL = function (state, val) {
  state.stepLabel = val
}

export const CHANGE_FIELDS_ORDERING = function (state, val) {
  state.fieldsOrdering = val
}

export const CHANGE_LEAD_STATUS = function (state, val) {
  state.leadStatus = val
}

export const UPDATE_STEPS_CRO = function (state, { field, incr }) {
  console.log('UPDATE_STEPS_CRO', field, incr)
  if (incr > 0 && !state.stepsCRO.includes(field)) state.stepsCRO.push(field)
  if (incr < 0) {
    let index = state.stepsCRO.indexOf(field)
    if (index > -1) state.stepsCRO.splice(index, 1)
  }
}

export const SHOW_AUTH_TEXT = function (state, val) {
  if (!state.authTextDomains.includes(window.location.hostname) && val) return
  const welcomeForPartner = getURLParameter('welcome')
  if (!welcomeForPartner) return
  state.showAuthText = val
}

export const SHOW_SKIP_BUTTON = function (state, val) {
  state.showSkipButton = val
}

export const UPDATE_REMOTE_AGREEMENTS_ERRORS = function (state, data) {
  const newErrors = [...state.remoteAgreementsErrors]

  const index = newErrors.indexOf(data.key)
  if (data.value) {
    if (index !== -1) newErrors.splice(index, 1)
  } else {
    if (index === -1) newErrors.push(data.key)
  }

  state.remoteAgreementsErrors = newErrors
}



// WEBPACK FOOTER //
// ./src/store/mutations.js